import { render, staticRenderFns } from "./ArrangeDemo.vue?vue&type=template&id=1bde9e9d&scoped=true&"
import script from "./ArrangeDemo.vue?vue&type=script&lang=js&"
export * from "./ArrangeDemo.vue?vue&type=script&lang=js&"
import style0 from "./ArrangeDemo.vue?vue&type=style&index=0&id=1bde9e9d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bde9e9d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer})
